// extracted by mini-css-extract-plugin
module.exports = {"fullWidthImage":"full-width-image_fullWidthImage__31GsO","marginBottom":"full-width-image_marginBottom__1NNvd"};